import React, {useState, useEffect} from "react";

import { API_URL, GET_ADMIN_RATES } from "../../../constants";
import { GET_TOKEN, OBJECT_EMPTY } from "../../../helpers";
import { LoadingSpinner } from "../../dashboard/partials/LoadingSpinner";
import { Input } from "../../Global/Input/Input";
import { EmptyData } from "../../Global/EmptyData/EmptyData";

import "./AdminRates.css";

export const AdminRates = () => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [ratesData, setRatesData] = useState([]);

  useEffect(() => {
    fetch(API_URL + GET_ADMIN_RATES, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => setRatesData(response))
      .catch(err => console.log(err))
      .finally(() => setDataLoaded(true))

  }, []);

  const submitRate = (id, rate) => {
    const body = JSON.stringify({
      rate
    })

    fetch(API_URL + GET_ADMIN_RATES + id, {
      method: "POST",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
        body
      }),
    })
      .catch(err => console.log(err))
  }

  const RatesList = () => {
    return <div className="currency-container flex" key="__RatesList">
      {ratesData?.rates?.map(item => {    
        return <div className="currency-card flex border" key={item.id + "__RatesList"}>
          <h4 className="currency-card_symbol">{item.currency}</h4>
  
          <div className="currency-card_compare">
            <h4 className="title">{item.currency} to EUR </h4>
            <div className="date">{item.time} </div>
          </div>
  
          <div className="currency-card_rate">
            <Input 
              type="number"
              defaultValue={item.rate}
              inputBlurHandler={(value) => submitRate(item.id, value)}
            />
          </div>
        </div>
      })}
    </div>
  }

  const ECBRatesList = () => {
    return <div className="currency-container flex" key="__RatesListECB">
      {ratesData?.ecb?.map(item => {    
        return <div className="currency-card flex border" key={item.id + "__RatesListECB"}>
          <h4 className="currency-card_symbol">{item.currency}</h4>
  
          <div className="currency-card_compare">
            <h4 className="title">{item.currency} to EUR </h4>
            <div className="date">{item.time} </div>
          </div>
  
          <div className="currency-card_rate">
            <Input 
              type="number"
              defaultValue={item.rate}
              disabled
              // inputBlurHandler={(value) => submitRate(item.id, value)}
            />
          </div>
        </div>
      })}
    </div>
  }
  
  return (
    <div className='AdminRates'>
      <div className="Dashboard__content__top-row">
        <h2> Currency rates </h2>
      </div>

      {dataLoaded 
        ? ratesData?.rates?.length > 0 
          ? [RatesList(), ECBRatesList()] 
          // ? <h1>RatesList()</h1> 
          : <EmptyData title="No returns data found" />
        : <LoadingSpinner/>
      }
    </div>
  );
};
